import { render, staticRenderFns } from "./showPost.vue?vue&type=template&id=a3978c24&scoped=true&style=color%3Argb(233%2C%20236%2C%20239)%3B%20background-color%3Argb(233%2C%20236%2C%20239)"
import script from "./showPost.vue?vue&type=script&lang=js"
export * from "./showPost.vue?vue&type=script&lang=js"
import style0 from "./showPost.vue?vue&type=style&index=0&id=a3978c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3978c24",
  null
  
)

export default component.exports